import { useMutation } from '@tanstack/react-query';
import cloneDeep from 'lodash/cloneDeep';
import { useTranslation } from 'react-i18next';

import { queryClient } from '@hero/clients';
import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useBulkUpsertContact = options => {
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(
    async body => {
      const result = [];

      const { tags, contacts } = cloneDeep(body);

      while (contacts.length > 0) {
        const chunk = contacts.splice(0, 2000);

        const response = await contactServices.bulkUpsertContact({
          tags,
          contacts: chunk
        });

        result.push(response);
      }

      return result.reduce((acc, resp) => [...acc, ...resp], []);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetContactsKey] });
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetTagListKey] });

        showSuccess({
          message: t('importSpreadSheetSuccess'),
          type: 'toast'
        });
      },
      ...options
    }
  );
};
